import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";

export default function WalletPage() {
  const nav = useNavigate();
  useEffect(() => {
    const t = setTimeout(() => nav("/rewards", { replace: true }), 8000);
    return () => clearTimeout(t);
  }, [nav]);
  return (
    <div className="mx-auto max-w-xl px-6 py-24 text-center" data-testid="wallet-retired">
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10">
        <Sparkles className="h-6 w-6 text-primary" />
      </div>
      <h1 className="mt-6 font-display text-3xl">Spend-only wallet</h1>
      <p className="mt-3 text-muted-foreground">
        Your wallet is <strong>spend-only</strong> — no withdrawals, no cash-outs, no PayPal payouts. Money you add is meant to be used inside Zuntria on services, AI credits and upgrades. <strong>Any balance left unspent for 2 days is automatically converted to app revenue</strong>, so don't hold money here — spend it on your success.
      </p>
      <p className="mt-2 text-xs text-muted-foreground">Redirecting to Rewards…</p>
    </div>
  );
}
